import { Controller } from "@hotwired/stimulus";

var HubCompanySearchController = class extends Controller {
  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this);
    document.addEventListener("click", this.boundCloseOnClickOutside);

    this.optionTargets.forEach((option) => {
      const checkbox = option.querySelector('input[type="checkbox"]');
      // biome-ignore lint/complexity/useOptionalChain: optional chaining not supported by Babel config
      if (checkbox && checkbox.checked) {
        this.addTag(checkbox.value, option.dataset.label);
      }
    });
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside);
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim();
    let visibleCount = 0;

    this.optionTargets.forEach((option) => {
      const matches = !query || option.dataset.label.includes(query);
      option.hidden = !matches;
      if (matches) visibleCount++;
    });

    this.emptyStateTarget.hidden = visibleCount > 0;
    this.positionDropdown();
    this.dropdownTarget.hidden = false;
  }

  open() {
    this.positionDropdown();
    this.dropdownTarget.hidden = false;
  }

  positionDropdown() {
    const inputRect = this.searchTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - inputRect.bottom;
    const above = spaceBelow < 220;
    this.dropdownTarget.classList.toggle(
      "hub-company-search__dropdown--above",
      above,
    );
  }

  onKeydown(e) {
    if (e.key === "Escape") {
      this.dropdownTarget.hidden = true;
      this.searchTarget.blur();
    }
  }

  closeOnClickOutside(e) {
    if (!this.element.contains(e.target)) {
      this.dropdownTarget.hidden = true;
    }
  }

  toggleTag(e) {
    const checkbox = e.target;
    const option = checkbox.closest(
      '[data-hub-company-search-target="option"]',
    );
    if (checkbox.checked) {
      this.addTag(checkbox.value, option.dataset.label);
    } else {
      this.removeTag(checkbox.value);
    }
  }

  addTag(value, name) {
    if (this.tagsTarget.querySelector(`[data-value="${value}"]`)) return;

    const tag = document.createElement("span");
    tag.className = "hub-company-search__tag";
    tag.dataset.value = value;

    const nameSpan = document.createElement("span");
    nameSpan.textContent = name;

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.textContent = "×";
    removeBtn.addEventListener("click", () => this.removeTagByValue(value));

    tag.appendChild(nameSpan);
    tag.appendChild(removeBtn);
    this.tagsTarget.appendChild(tag);
  }

  removeTag(value) {
    const tag = this.tagsTarget.querySelector(`[data-value="${value}"]`);
    if (tag) tag.remove();
  }

  removeTagByValue(value) {
    this.removeTag(value);
    const option = this.optionTargets.find((o) => {
      const cb = o.querySelector('input[type="checkbox"]');
      return cb && cb.value === value;
    });
    if (option) {
      const checkbox = option.querySelector('input[type="checkbox"]');
      if (checkbox) checkbox.checked = false;
    }
  }
};

HubCompanySearchController.targets = [
  "search",
  "dropdown",
  "option",
  "tags",
  "emptyState",
];

export default HubCompanySearchController;
